import * as React from "react";
import moment from "moment";

function isDifferent(initial: any, current: any): boolean {
  if (moment.isMoment(initial) && moment.isMoment(current)) {
    return !initial.isSame(current);
  }
  if (typeof initial === "object" && initial !== null) {
    return Object.keys(initial).some((key) =>
      isDifferent(initial[key], current[key])
    );
  }
  return initial !== current;
}

export function useUnsavedChanges<T extends object>(
  initial: T | null,
  current: T
): { hasChanges: boolean } {
  const hasChanges = React.useMemo(() => {
    if (!initial) return false;
    return Object.keys(initial).some((section) =>
      isDifferent(
        initial[section as keyof T],
        current[section as keyof T]
      )
    );
  }, [initial, current]);

  return { hasChanges };
}
